<template>
  <div class="first" v-if="swiperList.length > 0">
    <swiper class="swiper" :options="swiperOption" ref="mySwiper" v-if="swiperList.length > 0">
      <swiper-slide v-for="item in swiperList" :key="item.title">
        <img class="video" v-if="item.data.video" src="@/assets/common/grayplay.png" @click="operateVideo(item)" />
        <video v-if="item.data.video" autoplay muted loop>
          <source :src="item.data.video" type="video/mp4">
        </video>
        <img v-else class="img" :src="item.data.picture" @click="clickImg(item)" />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination" />
    </swiper>
    <div ref="myVideo" class="popVideo" v-if="videoState">
      <div class="video">
        <video ref="myVideo" :src="video" controls autoplay>
        </video>
        <div class="video_close" @click="closeVideo">
          <i class="el-icon-close"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import VueAwesomeSwiper, { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import video1 from '@/assets/home/home_1_1.mp4'
import videobtn from '@/assets/common/grayplay.png'

import banner2 from '@/assets/home/home_1_2.jpg'
import banner3 from '@/assets/home/home_1_3.jpg'
import banner4 from '@/assets/home/home_1_4.jpg'

import { getHomeCarousel } from '@/request/api';

Vue.use(VueAwesomeSwiper)

export default {
  name: 'SwiperComponent',
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      videoState: false,
      swiperOption: {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        autoplay: {
          delay: 10000,
          disableOnInteraction: false
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        }
      },
      swiperList: [],
      video: ''
    }
  },
  setup() {
    return {};
  },
  methods: {
    // 操作视频播放、暂停
    operateVideo(item) {
      // console.log(item)
      this.video = item.data.video;
      this.videoState = true;
    },
    closeVideo() {
      this.videoState = false;
    },
    clickImg(item) {
      console.log(item)
      if (item.title) {
        window._hmt.push(['_trackEvent', '官网首页', '头部轮播', item.title]);
      }
      if (item.data.url) {
        this.$router.push(item.data.url)
      }
    }
  },
  mounted() {
    getHomeCarousel().then(res => {
      // console.log(res)
      this.swiperList = res.data;
    })
  }
};
</script>
<style scoped lang="scss">
.first {
  width: 100%;
  min-width: 960px;
  height: 56.25vw;
  // height: calc(100vh - 60px);
}

.swiper {
  width: 100%;
  min-width: 960px;
  height: 56.25vw;
}

.swiper-slide {
  position: relative;
  text-align: center;
  font-size: 18px;
  background: #fff;

  display: flex;
  justify-content: center;
  align-items: center;
}

.swiper-slide .video {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 70px;
  height: 70px;
  object-fit: cover;
  transform: translate(-50%, -50%);
  cursor: pointer;
  z-index: 1;
}

.swiper-slide .img,
.swiper-slide video {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper-pagination {
  bottom: 50px;

  ::v-deep .swiper-pagination-bullet {
    width: 60px;
    height: 2px;
    background: #FFFFFF;
    opacity: 0.3;
    border-radius: 0;

    &.swiper-pagination-bullet-active {
      opacity: 1;
    }
  }
}

.popVideo {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 999 !important;
  background: rgba(0, 0, 0, .85);

  .video {
    outline: none;
    max-width: 70%;
    max-height: 80vh;
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0 20px 40px rgb(0 0 0 / 50%);

    video {
      width: 100%;
      height: 100%;
    }
  }

  .video_close {
    color: #fff;
    position: absolute;
    right: 0;
    top: 0;
    z-index: 999;
    cursor: pointer;
    font-size: 30px;
  }

}
</style>
